const ERRORS = {
  UNSUPPORTED: 'Please enable browser cookies and local storage or try a supported browser.',
  JSON_PARSE: 'Please clear your browser cookies and local storage as your Saved Scenarios are corrupted.',
  CAPACITY: 'You have reached the limit on how many scenarios you can save.',
  GENERIC: 'Please enable browser cookies and local storage or try a supported browser.',
};

function isStorageSupported() {
  try {
    return 'localStorage' in window && window.localStorage !== null;
  } catch (e) {
    throw new Error(ERRORS.UNSUPPORTED);
  }
}

/**
 * Retrieve item from local storage
 * @param key {string}
 * @returns {object} parsed object or null if expired
 */
function get(key) {
  try {
    if (!isStorageSupported()) return null;
    
    const item = localStorage.getItem(key);
    if (!item) return null;
    
    const parsedItem = JSON.parse(item);
    
    // Check if this is a wrapped object with expiry
    if (parsedItem && typeof parsedItem === 'object' && 'value' in parsedItem) {
      // Check if expired
      if (parsedItem.expiry && Date.now() > parsedItem.expiry) {
        localStorage.removeItem(key);
        return null;
      }
      return parsedItem.value;
    }
    
    // Legacy support: return the item as-is if it's not wrapped
    return parsedItem;
  } catch (e) {
    if (e.message.startsWith('JSON.parse')) {
      throw new Error(ERRORS.JSON_PARSE);
    }
    throw new Error(ERRORS.GENERIC);
  }
}

/**
 * Add item to local storage
 * @param key {string}
 * @param value {object} to store in browser as string
 * @param expiryMs {number} optional expiry time in milliseconds
 * @returns {null}
 */
function set(key, value, expiryMs) {
  try {
    if (!isStorageSupported()) return null;
    
    let itemToStore = value;
    
    // If expiry is provided, wrap the value with expiry timestamp
    if (expiryMs && typeof expiryMs === 'number' && expiryMs > 0) {
      itemToStore = {
        value,
        expiry: Date.now() + expiryMs,
      };
    }
    
    return localStorage.setItem(key, JSON.stringify(itemToStore));
  } catch (e) {
    if (e.code === 22) {
      throw new Error(ERRORS.CAPACITY);
    }
    throw new Error(ERRORS.GENERIC);
  }
}

/**
 * Delete item from local storage
 */
function remove(key) {
  localStorage.removeItem(key);
}

const LocalStorageClient = {
  ERRORS,
  get,
  set,
  remove,
};

export default LocalStorageClient;
